import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { postVerifyEmail } from "../../../api/api";
import Loading from "../../../components/Loading";
import Banner from "../../components/Banner";
import InfoAction from "../../components/actionblock/Info";

export default function VerifyEmail() {
    const { payload } = useParams();

    const verifyEmailMutation = useMutation((payload) => postVerifyEmail(payload));

    useEffect(() => {
        verifyEmailMutation.mutate(payload);
    }, [payload]);

    return (
        <section className="verify_email">
            {verifyEmailMutation.isLoading ? (
                <Loading />
            ) : (
                <>
                    {verifyEmailMutation.isSuccess ? (
                        <Banner
                            component={
                                <InfoAction
                                    title="Je emailadres is bevestigd!"
                                    text={
                                        "Vanaf nu kun je meedoen met onze onderzoeken. Binnenkort ontvang je de eerste uitnodiging.<br/><br/>Heb je ook je telefoonnummer opgegeven? Vergeet niet om die ook te bevestigen via sms. Alleen dan kunnen we je via whatsapp uitnodigen voor onderzoeken."
                                    }
                                    primaryActionButton={{ link: "/", text: "Naar het Landelijk Ouderpanel" }}
                                />
                            }
                        />
                    ) : (
                        <Banner
                            component={
                                <InfoAction
                                    title="Je emailadres is niet bevestigd"
                                    text={
                                        "Het is helaas niet gelukt om je emailadres te bevestigen. Neem contact op met <a href='https://oudersenonderwijs.nl/contact/' target=_blank>Ouders & Onderwijs<a/>"
                                    }
                                    primaryActionButton={{ link: "/", text: "Naar het Landelijk Ouderpanel" }}
                                />
                            }
                        />
                    )}
                </>
            )}
        </section>
    );
}
